import Loading from 'component/Loading';
import React, { useEffect, useState } from 'react';
type IProps = {
  aysncFn: Promise<any>;
  asyncComponent: React.ReactElement;
}
const AsyncComponent: React.FC<IProps> = ({ aysncFn, asyncComponent }) => {
  const [Component, setComponent] = useState<React.ReactElement>(<Loading />);

  useEffect(() => {
    aysncFn.finally(() => {
      setComponent(asyncComponent);
    });
  }, []);

  return Component;
};

export default AsyncComponent;
